import React from "react";
import Select from "react-select";

const LeaveFilter = ({ setBillMonth, setConsumer, setBillStatus }) => {
  // Define options for Bill Month, Consumer Category, and Bill Status
  const billMonth = [
    { value: "6", label: "July 2024" },
    { value: "7", label: "August 2024" },
    { value: "8", label: "September 2024" },
  ];

  const consumer = [
    { value: "DS", label: "DS" },
    { value: "NDS", label: "NDS" },
    { value: "LT", label: "LT" },
    { value: "AGRI", label: "AGRI" },
  ];

  const billStatus = [
    { value: "ALL", label: "ALL" },
    { value: "YES", label: "YES" },
    { value: "NO", label: "NO" },
  ];

  // Stats for payment done
  const leaveStats = [
    {
      id: 1,
      title: "Payment Done:",
      value: "Yes",
      value2: "No",
    },
  ];

  // Custom styles for react-select
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
    control: (provided) => ({
      ...provided,
      borderColor: "#ff9b44", // Custom border color
      height: "70px", // Increase height of the control (dropdown box)
      minHeight: "50px", // Ensure minimum height is applied
      boxShadow: "none",
      "&:hover": {
        borderColor: "#ff9b44", // Focus border color
      },
    }),
  };

  // Handle Bill Month Change (Single Select, returning as an array)
  const handleBillMonth = (selectedOption) => {
    setBillMonth(selectedOption ? [selectedOption.value] : []);
  };

  // Handle Consumer Category Change (Multi Select)
  const handleConsumerCategory = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setConsumer(selectedValues);
  };

  // Handle Bill Status Change (Single Select)
  const handleBillStatusChange = (selectedOption) => {
    setBillStatus(selectedOption ? selectedOption.value : "");
  };

  return (
    <div>
      {/* Search Filter */}
      <div className="row filter-row">
        {/* Bill Month Dropdown */}
        <div className="col-sm-6 col-md-3 col-lg-3 col-xl-4 col-12">
          <div className="input-block mb-3 form-focus select-focus">
            <Select
              options={billMonth}
              onChange={handleBillMonth}
              placeholder="July 2024"
              styles={customStyles}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
            />
            <label className="focus-label"></label>
          </div>
        </div>

        {/* Consumer Category Dropdown */}
        <div className="col-sm-6 col-md-3 col-lg-3 col-xl-4 col-12">
          <div className="input-block mb-3 form-focus select-focus">
            <Select
              isMulti
              options={consumer}
              onChange={handleConsumerCategory}
              placeholder="DS"
              styles={customStyles}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
            />
            <label className="focus-label"></label>
          </div>
        </div>

        {/* Payment Done Stats */}
        <div className="col-sm-6 col-md-3 col-lg-3 col-xl-4 col-12">
          <div className="input-block mb-3 form-focus select-focus">
            {leaveStats.map((stat, index) => (
              <div className="col-md-12" key={index}>
                <div className="stats-info" style={{ height: "70px" }}>
                  <span>Color Legend</span>
                  <br />
                  <span style={{ fontSize: "18px" }}>{stat.title}</span>&nbsp;
                  <span style={{ color: "#EA580C", fontSize: "18px" }}>Unpaid</span>&nbsp;&nbsp;
                  <span style={{ color: "#82ca9d", fontSize: "18px" }}>Paid</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveFilter;
